import React from 'react';
import ContactUs from '../Components/InfoPages/ContactUs';

function ContactPage() {
  return <ContactUs />;
}

export default ContactPage;
